module.exports = __webpack_public_path__ + "img/9.89b868af.svg";